export class TransactionNoContentError extends Error {}
